import { SearchDropdown, SearchInput } from "@/features/shop";
import { SearchBarProps } from "@/features/shop/types/searchBar.types";

export const SearchBar = ({
  value,
  onChange,
  onFocus,
  onBlur,
  results,
  isDropdownOpen,
  onSelectResult,
  placeholder = "Disneyland Paris, Amazon, Fnac, Netflix, Parc Astérix, Camping ...",
  showClearButton,
  onClear,
  onSubmit,
}: SearchBarProps) => {
  return (
    <div
      className="relative z-10 w-full"
      onBlur={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
          onBlur();
        }
      }}
    >

      <SearchInput
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        placeholder={placeholder}
        showClearButton={showClearButton}
        onClear={onClear}
        onSubmit={onSubmit}
      />

      <SearchDropdown
        results={results}
        onSelectResult={onSelectResult}
        isOpen={isDropdownOpen}
      />
    </div>
  );
};
